/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.ProductClass_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.ProductClass domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ProductClass_ {
   /// <summary>
   ///   Unresolved ()
   /// </summary>
   Unresolved = 0,
   /// <summary>
   ///   Traditional Subscription (SUBS)
   /// </summary>
   TraditionalSubscription = 1,
   /// <summary>
   ///   Book Membership (BOOKS)
   /// </summary>
   BookMembership = 2,
   /// <summary>
   ///   Renewal Only (RENEW)
   /// </summary>
   RenewalOnly = 3,
   /// <summary>
   ///   Partner Agreement (PARTNER)
   /// </summary>
   PartnerAgreement = 99
}

export const ProductClasses: ProductClass[] = [
   {
      code: ProductClass_.Unresolved,
      literal: 'Unresolved',
      description: 'Unresolved',
      shortDescription: '',
      listPriority: 0,

      isTaxable: false,

      typeName: "ProductClass"
   },
   {
      code: ProductClass_.TraditionalSubscription,
      literal: 'TraditionalSubscription',
      description: 'Traditional Subscription',
      shortDescription: 'SUBS',
      listPriority: 0,

      isTaxable: false,

      typeName: "ProductClass"
   },
   {
      code: ProductClass_.BookMembership,
      literal: 'BookMembership',
      description: 'Book Membership',
      shortDescription: 'BOOKS',
      listPriority: 0,

      isTaxable: true,

      typeName: "ProductClass"
   },
   {
      code: ProductClass_.RenewalOnly,
      literal: 'RenewalOnly',
      description: 'Renewal Only',
      shortDescription: 'RENEW',
      listPriority: 0,

      isTaxable: false,

      typeName: "ProductClass"
   },
   {
      code: ProductClass_.PartnerAgreement,
      literal: 'PartnerAgreement',
      description: 'Partner Agreement',
      shortDescription: 'PARTNER',
      listPriority: 0,

      isTaxable: false,

      typeName: "ProductClass"
   }
]

export class ProductClass implements IDomainModel {
   code: ProductClass_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   isTaxable: boolean

   typeName: string

   static toDomainModel(code: ProductClass_): ProductClass {
      return ProductClasses.find(d => d.code === code)
   }
}
